const FrameIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      data-testid="video-indication-icon"
    >
      <g clipPath="url(#clip0_453_2653)">
        <g filter="url(#filter0_d_453_2653)">
          <path
            d="M1 3.5C1 2.83696 1.26339 2.20107 1.73223 1.73223C2.20107 1.26339 2.83696 1 3.5 1H8.5C9.16304 1 9.79893 1.26339 10.2678 1.73223C10.7366 2.20107 11 2.83696 11 3.5V8.5C11 9.16304 10.7366 9.79893 10.2678 10.2678C9.79893 10.7366 9.16304 11 8.5 11H3.5C2.83696 11 2.20107 10.7366 1.73223 10.2678C1.26339 9.79893 1 9.16304 1 8.5V3.5Z"
            stroke="currentColor"
            strokeWidth="0.625"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g filter="url(#filter1_d_453_2653)">
            <path
              d="M5.31094 4.20729C5.17803 4.11869 5 4.21396 5 4.3737V7.6263C5 7.78604 5.17803 7.88131 5.31094 7.79271L7.75039 6.16641C7.86913 6.08725 7.86913 5.91275 7.75038 5.83359L5.31094 4.20729Z"
              fill="currentColor"
            />
            <path
              d="M5.31094 4.20729C5.17803 4.11869 5 4.21396 5 4.3737V7.6263C5 7.78604 5.17803 7.88131 5.31094 7.79271L7.75039 6.16641C7.86913 6.08725 7.86913 5.91275 7.75038 5.83359L5.31094 4.20729Z"
              stroke="currentColor"
              strokeWidth="0.625"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_453_2653"
          x="-0.4375"
          y="-0.4375"
          width="12.875"
          height="12.875"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5625" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_453_2653"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_453_2653"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_453_2653"
          x="3.4125"
          y="2.58535"
          width="6.01436"
          height="6.8293"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.6375" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_453_2653"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_453_2653"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_453_2653">
          <rect width="12" height="12" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FrameIcon;
